import React from "react";
import { IoMdCheckmark } from "react-icons/io";
interface StepperProps {
  steps: string[];
  currentStep: number;
  onStepChange?: (step: number) => void;
}

const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  onStepChange,
}) => {
  const handleStepClick = (index: number) => {
    if (onStepChange && index <= currentStep) {
      onStepChange(index);
    }
  };

  return (
    <div className="w-full px-8 py-12">
      <div className="flex items-start relative">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center relative">
              {/* Circle with number or checkmark */}
              <button
                className={`w-8 h-8 rounded-full flex items-center justify-center text-lg font-semibold transition-all relative z-10 ${
                  index < currentStep
                    ? "bg-green-500 text-white"
                    : index === currentStep
                    ? "bg-white text-[#00032A] border-4 border-[#00032A]"
                    : "bg-[#E0E0E0] text-[#BDBDBD] border-4 border-[#BDBDBD]"
                }`}
                onClick={() => handleStepClick(index)}
                disabled={index > currentStep}
              >
                {index < currentStep ? (
                  <div className="">
                    <div>✔</div>
                  </div>
                ) : (
                  index + 1
                )}
              </button>

              {/* Step label */}
              <span
                className={`mt-3 text-[14px] ${
                  index <= currentStep ? "text-fleetblack" : "text-gray-400"
                }`}
              >
                {step}
              </span>
            </div>

            {/* Connecting line - straight for completed, dashed for incomplete */}
            {index < steps.length - 1 && (
              <div
                className="flex-1 h-0.5 self-start"
                style={{
                  marginTop: "16px",
                  background: index < currentStep ? "#BDBDBD" : "transparent",
                  backgroundImage:
                    index < currentStep 
                      ? "none"
                      : "repeating-linear-gradient(to right, #E0E0E0 0, #d1d5db 8px, transparent 8px, transparent 16px)",
                }}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
export default Stepper;
